import React from 'react';
import Link from 'next/link';
import RoundIcon from '@avila-tek/ui/src/icons/RoundIcon';
import { Button } from '@avila-tek/ui/src';
import { ButtonInfo } from '../../../models';

interface HomeButtonBannerAlliesProps {
  buttonsArray: ButtonInfo[];
}

export default function HomeButtonBannerAllies({
  buttonsArray,
}: HomeButtonBannerAlliesProps) {
  if (!buttonsArray?.length) {
    return (
      <>
        <Link
          href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/company`}
          target="_blank"
          rel="noreferrer"
        >
          <button
            type="button"
            className="py-2 px-4 rounded tracking-wide transition-colors bg-color-primary-300 text-system-100 w-full hover:bg-color-primary-200"
          >
            <div className="flex flex-row items-center justify-between w-full space-x-10">
              <div className="text-left lg:text-lg xl:text-lg text-xs md:text-base sm:whitespace-nowrap">
                ¿Quieres ofrecer beneficios a tus empleados?
              </div>
              <RoundIcon className="flex justify-center text-cold-500 w-6 ml-auto" />
            </div>
          </button>
        </Link>
        <Link
          href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/ally`}
          target="_blank"
        >
          <button
            type="button"
            className="py-2 px-4 rounded tracking-wide transition-colors bg-color-primary-300 text-system-100 w-full hover:bg-color-primary-200"
          >
            <div className="flex flex-row items-center justify-between w-full space-x-10">
              <div className="text-left lg:text-lg xl:text-lg text-xs md:text-base sm:whitespace-nowrap">
                {' '}
                ¿Quieres ofrecer tus productos en Meit!?
              </div>
              <RoundIcon className="flex justify-center text-cold-500 w-6 ml-auto" />
            </div>
          </button>
        </Link>
      </>
    );
  }

  return (
    <>
      {buttonsArray.slice(0, 3).map((button, index) => (
        <Button
          key={index}
          type="button"
          className="bg-color-primary-300 text-system-100 hover:bg-color-primary-200 font-normal border-0 w-auto"
        >
          <Link href={button.action} target="_blank">
            <div className="flex flex-row items-center justify-between w-full space-x-10">
              <div className="sm:whitespace-nowrap">{button.title}</div>
              <div className="">
                <RoundIcon className=" w-6" />
              </div>
            </div>
          </Link>
        </Button>
      ))}
    </>
  );
}
